import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { Component } from 'react';
import { BASE_PLOT_OPTIONS, CHART_BASE_CONFIG, X_AXIS_BASE_CONFIG, Y_AXIS_BASE_CONFIG } from './ChartBaseConfig';

export default class Agreement extends Component {
	chart;
	offset;
	state = {
		options: this.getChartOptions()
	};
	updateDimensions() {
		this.offset = this.chart.container.parentElement.clientWidth;
		const interval = parseInt(process.env.REACT_APP_PAST_CHARTS_INTEVAL, 10);
		this.chart.setSize(this.props.data.length * (this.offset / (this.props.frameRate * interval)));
		this.translateChart(this.props.currentDataIndex);
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions.bind(this));
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
	}
	getChartOptions() {
		return {
			...CHART_BASE_CONFIG,
			chart: {
				backgroundColor: null,
				animation: false,
				margin: [0, 0, 0, 0],
				width: this.props.data.length * 6
			},
			tooltip: {
				animation: false,
				shared: true,
				formatter: () => false
			},
			series: [{
				data: this.props.data.map(a => ({
					x: a.timestamp,
					y: a.delta,
					color: a.delta < (a.valueUpperBound - a.valueLowerBound) / 2 ? '#2b578b' : '#a1caf9'})),
				type: 'column',
				// color: '#2b578b', // a1caf9 ligh blue
				borderColor: 'transparent',
				name: 'Agreement Delta'
			}],
			plotOptions: {
				...BASE_PLOT_OPTIONS
			},
			xAxis: [{
				...X_AXIS_BASE_CONFIG,
			}],
			yAxis: [{
				...Y_AXIS_BASE_CONFIG,
			}]
		}
	}
	componentDidUpdate(prevProps) {
		if (this.props.videoReady !== prevProps.videoReady && this.props.videoReady) {
			setTimeout(() => {
				this.chart.reflow();
				this.updateDimensions();
			}, 1000);
		}

	}
	shouldComponentUpdate(nextProps){
		if (this.chart && this.props.currentDataIndex !== nextProps.currentDataIndex) {
			this.translateChart(nextProps.currentDataIndex);
		}
		return this.props.videoReady !== nextProps.videoReady && nextProps.videoReady;
	}
	translateChart(currentDataIndex) {
		this.chart.container.style.transform = `translateX(${
			- ((this.chart.container.clientWidth / this.props.data.length) * currentDataIndex) + this.offset
		}px) translateZ(0)`;
	}
	chartCallback(chart) {
		this.chart = chart;
		this.chart.container.style.transform = 'translateX(1000px)';
	}
	render() {
		return (
			<HighchartsReact
				highcharts={Highcharts}
				options={this.state.options}
				callback={this.chartCallback.bind(this)}
			/>
		);
	}
}